/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { OdataAktOrtSaveRequest } from '../models/odata-akt-ort-save-request';
import { OdataAktOrtResponse } from '../models/odata-akt-ort-response';
import { FairAppSimpleRequest } from '../models/fair-app-simple-request';
import { OdataAktOrtDetailPatchPost } from '../models/odata-akt-ort-detail-patch-post';
import { FairAppOdataAktRequest } from '../models/fair-app-odata-akt-request';
import { OdataAktOrtDetailPatchMultiple } from '../models/odata-akt-ort-detail-patch-multiple';
import { OdataAktOrtDetailResponse } from '../models/odata-akt-ort-detail-response';
import { AllowedResponse } from '../models/allowed-response';
import { AktListResponse } from '../models/akt-list-response';
import { AktListRetrieveRequest } from '../models/akt-list-retrieve-request';
import { OdataAktAktartResponse } from '../models/odata-akt-aktart-response';
import { OdataGeneralAktRequest } from '../models/odata-general-akt-request';
import { AktOwncloudFolderRequest } from '../models/akt-owncloud-folder-request';
import { AktSchadenaufstellungResponse } from '../models/akt-schadenaufstellung-response';
import { FairAppSnrToggleRequest } from '../models/fair-app-snr-toggle-request';
import { FairAppSimpleToggleRequest } from '../models/fair-app-simple-toggle-request';
import { AktSchadenaufstellungCreateUpdate } from '../models/akt-schadenaufstellung-create-update';
import { FairAppRequest } from '../models/fair-app-request';
import { OdataAktPersonResponse } from '../models/odata-akt-person-response';
import { OdataZeitabrechnungResponse } from '../models/odata-zeitabrechnung-response';
import { OdataZeitabrechnungPatchPost } from '../models/odata-zeitabrechnung-patch-post';
import { OdataZeitabrechnungBatchPatchPost } from '../models/odata-zeitabrechnung-batch-patch-post';
@Injectable({
  providedIn: 'root',
})
class AktService extends __BaseService {
  static readonly aktAktortOdataPatchCreatePath = '/akt/aktort/odata/patch';
  static readonly aktAktortOdataPrimaryChangeCreatePath = '/akt/aktort/odata/primary/change';
  static readonly aktAktortOdataRetrieveCreatePath = '/akt/aktort/odata/retrieve';
  static readonly aktAktortdetailOdataCreateCreatePath = '/akt/aktortdetail/odata/create';
  static readonly aktAktortdetailOdataDeleteCreatePath = '/akt/aktortdetail/odata/delete';
  static readonly aktAktortdetailOdataPatchCreatePath = '/akt/aktortdetail/odata/patch';
  static readonly aktAktortdetailOdataPatchMultipleCreatePath = '/akt/aktortdetail/odata/patch-multiple';
  static readonly aktAktortdetailOdataRetrieveCreatePath = '/akt/aktortdetail/odata/retrieve';
  static readonly aktIsUploadAllowedCreatePath = '/akt/is-upload-allowed';
  static readonly aktListCreatePath = '/akt/list';
  static readonly aktOdataAktartRetrieveCreatePath = '/akt/odata/aktart/retrieve';
  static readonly aktOdataRetrieveCreatePath = '/akt/odata/retrieve';
  static readonly aktOwncloudFolderRetrieveCreatePath = '/akt/owncloud-folder/retrieve';
  static readonly aktSchadenaufstellungCustomerAccessToggleCreatePath = '/akt/schadenaufstellung/customer-access/toggle';
  static readonly aktSchadenaufstellungCustomerSubmitToggleCreatePath = '/akt/schadenaufstellung/customer-submit/toggle';
  static readonly aktSchadenaufstellungPdfCreatePath = '/akt/schadenaufstellung/pdf';
  static readonly aktSchadenaufstellungPostCreatePath = '/akt/schadenaufstellung/post';
  static readonly aktSchadenaufstellungRetrieveListPath = '/akt/schadenaufstellung/retrieve';
  static readonly aktSchadenaufstellungRetrieveCreatePath = '/akt/schadenaufstellung/retrieve';
  static readonly aktSchadenaufstellungUploadPdfCreatePath = '/akt/schadenaufstellung/upload-pdf';
  static readonly aktVersicherungOdataRetrieveCreatePath = '/akt/versicherung/odata/retrieve';
  static readonly aktZeitabrechnungOdataDeleteCreatePath = '/akt/zeitabrechnung/odata/delete';
  static readonly aktZeitabrechnungOdataListRetrieveCreatePath = '/akt/zeitabrechnung/odata/list/retrieve';
  static readonly aktZeitabrechnungOdataPatchCreatePath = '/akt/zeitabrechnung/odata/patch';
  static readonly aktZeitabrechnungOdataPostCreatePath = '/akt/zeitabrechnung/odata/post';
  static readonly aktZeitabrechnungOdataRetrieveCreatePath = '/akt/zeitabrechnung/odata/retrieve';
  static readonly aktZeitabrechnungOdataSortorderBatchPatchCreatePath = '/akt/zeitabrechnung/odata/sortorder/batch/patch';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param data undefined
   */
  aktAktortOdataPatchCreateResponse(data: OdataAktOrtSaveRequest): __Observable<__StrictHttpResponse<OdataAktOrtSaveRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/aktort/odata/patch`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataAktOrtSaveRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktAktortOdataPatchCreate(data: OdataAktOrtSaveRequest): __Observable<OdataAktOrtSaveRequest> {
    return this.aktAktortOdataPatchCreateResponse(data).pipe(
      __map(_r => _r.body as OdataAktOrtSaveRequest)
    );
  }

  /**
   * @param data undefined
   */
  aktAktortOdataPrimaryChangeCreateResponse(data: OdataAktOrtSaveRequest): __Observable<__StrictHttpResponse<OdataAktOrtResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/aktort/odata/primary/change`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataAktOrtResponse>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktAktortOdataPrimaryChangeCreate(data: OdataAktOrtSaveRequest): __Observable<OdataAktOrtResponse> {
    return this.aktAktortOdataPrimaryChangeCreateResponse(data).pipe(
      __map(_r => _r.body as OdataAktOrtResponse)
    );
  }

  /**
   * @param data undefined
   */
  aktAktortOdataRetrieveCreateResponse(data: FairAppSimpleRequest): __Observable<__StrictHttpResponse<Array<OdataAktOrtResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/aktort/odata/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<OdataAktOrtResponse>>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktAktortOdataRetrieveCreate(data: FairAppSimpleRequest): __Observable<Array<OdataAktOrtResponse>> {
    return this.aktAktortOdataRetrieveCreateResponse(data).pipe(
      __map(_r => _r.body as Array<OdataAktOrtResponse>)
    );
  }

  /**
   * @param data undefined
   */
  aktAktortdetailOdataCreateCreateResponse(data: OdataAktOrtDetailPatchPost): __Observable<__StrictHttpResponse<OdataAktOrtDetailPatchPost>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/aktortdetail/odata/create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataAktOrtDetailPatchPost>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktAktortdetailOdataCreateCreate(data: OdataAktOrtDetailPatchPost): __Observable<OdataAktOrtDetailPatchPost> {
    return this.aktAktortdetailOdataCreateCreateResponse(data).pipe(
      __map(_r => _r.body as OdataAktOrtDetailPatchPost)
    );
  }

  /**
   * @param data undefined
   */
  aktAktortdetailOdataDeleteCreateResponse(data: FairAppOdataAktRequest): __Observable<__StrictHttpResponse<FairAppOdataAktRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/aktortdetail/odata/delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FairAppOdataAktRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktAktortdetailOdataDeleteCreate(data: FairAppOdataAktRequest): __Observable<FairAppOdataAktRequest> {
    return this.aktAktortdetailOdataDeleteCreateResponse(data).pipe(
      __map(_r => _r.body as FairAppOdataAktRequest)
    );
  }

  /**
   * @param data undefined
   */
  aktAktortdetailOdataPatchCreateResponse(data: OdataAktOrtDetailPatchPost): __Observable<__StrictHttpResponse<OdataAktOrtDetailPatchPost>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/aktortdetail/odata/patch`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataAktOrtDetailPatchPost>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktAktortdetailOdataPatchCreate(data: OdataAktOrtDetailPatchPost): __Observable<OdataAktOrtDetailPatchPost> {
    return this.aktAktortdetailOdataPatchCreateResponse(data).pipe(
      __map(_r => _r.body as OdataAktOrtDetailPatchPost)
    );
  }

  /**
   * @param data undefined
   */
  aktAktortdetailOdataPatchMultipleCreateResponse(data: OdataAktOrtDetailPatchMultiple): __Observable<__StrictHttpResponse<OdataAktOrtDetailPatchMultiple>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/aktortdetail/odata/patch-multiple`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataAktOrtDetailPatchMultiple>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktAktortdetailOdataPatchMultipleCreate(data: OdataAktOrtDetailPatchMultiple): __Observable<OdataAktOrtDetailPatchMultiple> {
    return this.aktAktortdetailOdataPatchMultipleCreateResponse(data).pipe(
      __map(_r => _r.body as OdataAktOrtDetailPatchMultiple)
    );
  }

  /**
   * @param data undefined
   */
  aktAktortdetailOdataRetrieveCreateResponse(data: FairAppSimpleRequest): __Observable<__StrictHttpResponse<Array<OdataAktOrtDetailResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/aktortdetail/odata/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<OdataAktOrtDetailResponse>>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktAktortdetailOdataRetrieveCreate(data: FairAppSimpleRequest): __Observable<Array<OdataAktOrtDetailResponse>> {
    return this.aktAktortdetailOdataRetrieveCreateResponse(data).pipe(
      __map(_r => _r.body as Array<OdataAktOrtDetailResponse>)
    );
  }

  /**
   * @param data undefined
   */
  aktIsUploadAllowedCreateResponse(data: FairAppSimpleRequest): __Observable<__StrictHttpResponse<AllowedResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/is-upload-allowed`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AllowedResponse>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktIsUploadAllowedCreate(data: FairAppSimpleRequest): __Observable<AllowedResponse> {
    return this.aktIsUploadAllowedCreateResponse(data).pipe(
      __map(_r => _r.body as AllowedResponse)
    );
  }

  /**
   * @param data undefined
   */
  aktListCreateResponse(data: AktListRetrieveRequest): __Observable<__StrictHttpResponse<Array<AktListResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/list`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AktListResponse>>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktListCreate(data: AktListRetrieveRequest): __Observable<Array<AktListResponse>> {
    return this.aktListCreateResponse(data).pipe(
      __map(_r => _r.body as Array<AktListResponse>)
    );
  }

  /**
   * @param data undefined
   */
  aktOdataAktartRetrieveCreateResponse(data: FairAppSimpleRequest): __Observable<__StrictHttpResponse<OdataAktAktartResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/odata/aktart/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataAktAktartResponse>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktOdataAktartRetrieveCreate(data: FairAppSimpleRequest): __Observable<OdataAktAktartResponse> {
    return this.aktOdataAktartRetrieveCreateResponse(data).pipe(
      __map(_r => _r.body as OdataAktAktartResponse)
    );
  }

  /**
   * @param data undefined
   */
  aktOdataRetrieveCreateResponse(data: OdataGeneralAktRequest): __Observable<__StrictHttpResponse<OdataGeneralAktRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/odata/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataGeneralAktRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktOdataRetrieveCreate(data: OdataGeneralAktRequest): __Observable<OdataGeneralAktRequest> {
    return this.aktOdataRetrieveCreateResponse(data).pipe(
      __map(_r => _r.body as OdataGeneralAktRequest)
    );
  }

  /**
   * @param data undefined
   */
  aktOwncloudFolderRetrieveCreateResponse(data: AktOwncloudFolderRequest): __Observable<__StrictHttpResponse<AktOwncloudFolderRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/owncloud-folder/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AktOwncloudFolderRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktOwncloudFolderRetrieveCreate(data: AktOwncloudFolderRequest): __Observable<AktOwncloudFolderRequest> {
    return this.aktOwncloudFolderRetrieveCreateResponse(data).pipe(
      __map(_r => _r.body as AktOwncloudFolderRequest)
    );
  }

  /**
   * @param data undefined
   */
  aktSchadenaufstellungCustomerAccessToggleCreateResponse(data: FairAppSnrToggleRequest): __Observable<__StrictHttpResponse<AktSchadenaufstellungResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/schadenaufstellung/customer-access/toggle`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AktSchadenaufstellungResponse>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktSchadenaufstellungCustomerAccessToggleCreate(data: FairAppSnrToggleRequest): __Observable<AktSchadenaufstellungResponse> {
    return this.aktSchadenaufstellungCustomerAccessToggleCreateResponse(data).pipe(
      __map(_r => _r.body as AktSchadenaufstellungResponse)
    );
  }

  /**
   * @param data undefined
   */
  aktSchadenaufstellungCustomerSubmitToggleCreateResponse(data: FairAppSimpleToggleRequest): __Observable<__StrictHttpResponse<AktSchadenaufstellungResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/schadenaufstellung/customer-submit/toggle`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AktSchadenaufstellungResponse>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktSchadenaufstellungCustomerSubmitToggleCreate(data: FairAppSimpleToggleRequest): __Observable<AktSchadenaufstellungResponse> {
    return this.aktSchadenaufstellungCustomerSubmitToggleCreateResponse(data).pipe(
      __map(_r => _r.body as AktSchadenaufstellungResponse)
    );
  }

  /**
   * @param data undefined
   */
  aktSchadenaufstellungPdfCreateResponse(data: FairAppSimpleRequest): __Observable<__StrictHttpResponse<FairAppSimpleRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/schadenaufstellung/pdf`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FairAppSimpleRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktSchadenaufstellungPdfCreate(data: FairAppSimpleRequest): __Observable<FairAppSimpleRequest> {
    return this.aktSchadenaufstellungPdfCreateResponse(data).pipe(
      __map(_r => _r.body as FairAppSimpleRequest)
    );
  }

  /**
   * @param data undefined
   */
  aktSchadenaufstellungPostCreateResponse(data: AktSchadenaufstellungCreateUpdate): __Observable<__StrictHttpResponse<AktSchadenaufstellungResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/schadenaufstellung/post`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AktSchadenaufstellungResponse>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktSchadenaufstellungPostCreate(data: AktSchadenaufstellungCreateUpdate): __Observable<AktSchadenaufstellungResponse> {
    return this.aktSchadenaufstellungPostCreateResponse(data).pipe(
      __map(_r => _r.body as AktSchadenaufstellungResponse)
    );
  }
  aktSchadenaufstellungRetrieveListResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/akt/schadenaufstellung/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }  aktSchadenaufstellungRetrieveList(): __Observable<null> {
    return this.aktSchadenaufstellungRetrieveListResponse().pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param data undefined
   */
  aktSchadenaufstellungRetrieveCreateResponse(data: FairAppSimpleRequest): __Observable<__StrictHttpResponse<AktSchadenaufstellungResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/schadenaufstellung/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AktSchadenaufstellungResponse>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktSchadenaufstellungRetrieveCreate(data: FairAppSimpleRequest): __Observable<AktSchadenaufstellungResponse> {
    return this.aktSchadenaufstellungRetrieveCreateResponse(data).pipe(
      __map(_r => _r.body as AktSchadenaufstellungResponse)
    );
  }

  /**
   * @param data undefined
   */
  aktSchadenaufstellungUploadPdfCreateResponse(data: FairAppRequest): __Observable<__StrictHttpResponse<FairAppRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/schadenaufstellung/upload-pdf`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FairAppRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktSchadenaufstellungUploadPdfCreate(data: FairAppRequest): __Observable<FairAppRequest> {
    return this.aktSchadenaufstellungUploadPdfCreateResponse(data).pipe(
      __map(_r => _r.body as FairAppRequest)
    );
  }

  /**
   * @param data undefined
   */
  aktVersicherungOdataRetrieveCreateResponse(data: FairAppSimpleRequest): __Observable<__StrictHttpResponse<OdataAktPersonResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/versicherung/odata/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataAktPersonResponse>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktVersicherungOdataRetrieveCreate(data: FairAppSimpleRequest): __Observable<OdataAktPersonResponse> {
    return this.aktVersicherungOdataRetrieveCreateResponse(data).pipe(
      __map(_r => _r.body as OdataAktPersonResponse)
    );
  }

  /**
   * @param data undefined
   */
  aktZeitabrechnungOdataDeleteCreateResponse(data: FairAppOdataAktRequest): __Observable<__StrictHttpResponse<FairAppOdataAktRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/zeitabrechnung/odata/delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FairAppOdataAktRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktZeitabrechnungOdataDeleteCreate(data: FairAppOdataAktRequest): __Observable<FairAppOdataAktRequest> {
    return this.aktZeitabrechnungOdataDeleteCreateResponse(data).pipe(
      __map(_r => _r.body as FairAppOdataAktRequest)
    );
  }

  /**
   * @param data undefined
   */
  aktZeitabrechnungOdataListRetrieveCreateResponse(data: FairAppSimpleRequest): __Observable<__StrictHttpResponse<Array<OdataZeitabrechnungResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/zeitabrechnung/odata/list/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<OdataZeitabrechnungResponse>>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktZeitabrechnungOdataListRetrieveCreate(data: FairAppSimpleRequest): __Observable<Array<OdataZeitabrechnungResponse>> {
    return this.aktZeitabrechnungOdataListRetrieveCreateResponse(data).pipe(
      __map(_r => _r.body as Array<OdataZeitabrechnungResponse>)
    );
  }

  /**
   * @param data undefined
   */
  aktZeitabrechnungOdataPatchCreateResponse(data: OdataZeitabrechnungPatchPost): __Observable<__StrictHttpResponse<OdataZeitabrechnungPatchPost>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/zeitabrechnung/odata/patch`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataZeitabrechnungPatchPost>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktZeitabrechnungOdataPatchCreate(data: OdataZeitabrechnungPatchPost): __Observable<OdataZeitabrechnungPatchPost> {
    return this.aktZeitabrechnungOdataPatchCreateResponse(data).pipe(
      __map(_r => _r.body as OdataZeitabrechnungPatchPost)
    );
  }

  /**
   * @param data undefined
   */
  aktZeitabrechnungOdataPostCreateResponse(data: OdataZeitabrechnungPatchPost): __Observable<__StrictHttpResponse<OdataZeitabrechnungPatchPost>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/zeitabrechnung/odata/post`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataZeitabrechnungPatchPost>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktZeitabrechnungOdataPostCreate(data: OdataZeitabrechnungPatchPost): __Observable<OdataZeitabrechnungPatchPost> {
    return this.aktZeitabrechnungOdataPostCreateResponse(data).pipe(
      __map(_r => _r.body as OdataZeitabrechnungPatchPost)
    );
  }

  /**
   * @param data undefined
   */
  aktZeitabrechnungOdataRetrieveCreateResponse(data: FairAppOdataAktRequest): __Observable<__StrictHttpResponse<OdataZeitabrechnungResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/zeitabrechnung/odata/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataZeitabrechnungResponse>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktZeitabrechnungOdataRetrieveCreate(data: FairAppOdataAktRequest): __Observable<OdataZeitabrechnungResponse> {
    return this.aktZeitabrechnungOdataRetrieveCreateResponse(data).pipe(
      __map(_r => _r.body as OdataZeitabrechnungResponse)
    );
  }

  /**
   * @param data undefined
   */
  aktZeitabrechnungOdataSortorderBatchPatchCreateResponse(data: OdataZeitabrechnungBatchPatchPost): __Observable<__StrictHttpResponse<OdataZeitabrechnungBatchPatchPost>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/akt/zeitabrechnung/odata/sortorder/batch/patch`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataZeitabrechnungBatchPatchPost>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktZeitabrechnungOdataSortorderBatchPatchCreate(data: OdataZeitabrechnungBatchPatchPost): __Observable<OdataZeitabrechnungBatchPatchPost> {
    return this.aktZeitabrechnungOdataSortorderBatchPatchCreateResponse(data).pipe(
      __map(_r => _r.body as OdataZeitabrechnungBatchPatchPost)
    );
  }
}

module AktService {
}

export { AktService }
